import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTable, usePagination, useSortBy, useGlobalFilter, useAsyncDebounce, useFilters } from 'react-table'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import * as checkFont from "@fortawesome/free-solid-svg-icons";
import { faEdit, faHistory }  from "@fortawesome/free-solid-svg-icons";
import {  changeDataFullFormat_DDMMYYYY,  changeDataToDDMMYYYY } from '../../utils/Date/SupportDate';
import { useSelector } from 'react-redux';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`
// Define a default UI for filtering
function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
}) {
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined)
    }, 200)

    return (
        <div className="d-flex align-items-center mb-2" style={{ margin: 'auto' }}>
            <h4 > Search:{' '}</h4>
            <input
                className="ml-2 search_input"
                value={value || ""}
                onChange={e => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }}
                placeholder="Enter here key search"
            />
        </div>
    )
}

function Table({ columns, data, search, showIconOnName, selectIndex,
    onChangeSelectIndex, onChangeSelectIndex2, pageIndexShow,
    supportFunction1, role, type,
    onOpenEditCompany, onOpenHistory }) {
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page
        state,
        visibleColumns,
        preGlobalFilteredRows,
        setGlobalFilter,
        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },

    } = useTable(
        {
            columns,
            data,
            showIconOnName,
            initialState: { pageIndex: 0 },
            onOpenEditCompany,
            supportFunction1
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    )

    function checkHeader(value, cell, i) {
        switch (value) {
            case "Select" :
                return <input type="checkbox" onChange={() => supportFunction1(cell.value)}></input>
            case "Created At": case "Time":  
                return (changeDataFullFormat_DDMMYYYY(cell.value));
            case "Button": 
                return (<a href={"" + cell.value} target="_blank" rel="noreferrer">
                    {cell.column.buttonName}
                </a>);
            case "PassportPicture" : 
                return (<div className="op-hidden"></div>)
            case "View": return (<button className='btn btn-primary'
                                    onClick={()=>{
                                        onChangeSelectIndex(pageIndex*pageIndexShow + i)
                                        onChangeSelectIndex2(pageIndex*pageIndexShow + i)
                                    }}>View</button>);  
            case "Contract": case "Travel":
                return (<div>{cell.value ? "Yes": "No"}</div>)
            case "Price": 
                return (<div>{Number(cell.value).toLocaleString()}</div>)
            case "Sex":
                return (<div>{cell.value === true ? "female" : "male"}</div>)   
            case "Check In": case "Check Out": case "Birth Day": case "Birthday": 
                return (cell.value === "" || cell.value === undefined)? cell.value: (changeDataToDDMMYYYY(cell.value));
            default: return cell.render('Cell');
        }
    }

    function checkBackGroupItem(cell) {
        if(type === "company" ) {
           // console.log("cell", cell) // && cell.column.Header === "Contract"
            if (cell.row.original.contract === false) return 'red'
            else return ""
        } else return ""
    }

    useEffect(()=>{
        if (type === "guestCheckIn") {
            onChangeSelectIndex(pageIndex*pageIndexShow + 0)
            onChangeSelectIndex2(pageIndex*pageIndexShow + 0)
        } 
    },[pageIndex, pageIndexShow, type, onChangeSelectIndex, onChangeSelectIndex2])

    // Render the UI for your table
    return (
        <>
            <div className={(search || search === undefined) ? "pagination" : "op-hidden"}>
                <div
                    colSpan={visibleColumns.length}
                    style={{
                        textAlign: 'center',
                        alignItems: "center"
                    }}>
                    <GlobalFilter
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={state.globalFilter}
                        setGlobalFilter={setGlobalFilter} />
                </div>
                <div>
                    <button onClick={() =>  gotoPage(0)} 
                        disabled={!canPreviousPage}>
                        {'<<'}
                    </button>{' '}
                    <button onClick={() => {
                        previousPage()
                    }} 
                    disabled={!canPreviousPage}>
                        {'<'}
                    </button>{' '}
                    <button onClick={() => nextPage()} disabled={!canNextPage}>
                        {'>'}
                    </button>{' '}
                    <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        {'>>'}
                    </button>{' '}
                </div>

                <span>
                    Page{' '}
                    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                    </strong>{' '}
                </span>
                <span className="ml-5">
                    | Go to page:{' '}
                    <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={e => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                            gotoPage(page)
                        }}
                        style={{ width: '100px' }}
                    />
                </span>{' '}
                <select
                    value={pageSize}
                    onChange={e => {
                        setPageSize(Number(e.target.value))
                    }}
                >
                    {[10, 20, 30, 40, 50].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                        </option>
                    ))}
                </select>
            </div>

            <table {...getTableProps()} className="mt-3"
                style={{ margin: "auto", width:'90%' }}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>

                            {headerGroup.headers.map(column => {
                                return (
                                    <th
                                        // style={{ color: "red" }}
                                        className={column.class}
                                        // style={column.style}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        {/* <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </span> */}
                                    </th>
                                )
                            })}
                        </tr>
                    ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                    {page.map((row, i) => {
                        prepareRow(row)
                        //console.log("i", i)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                  //  console.log("cell.column.Header", cell.column.Header)
                                    return (
                                        <td style={{ fontSize: '1.4rem', 
                                                     background: (type === "guestCheckIn" && selectIndex === pageIndex*pageIndexShow+i) ? 'aqua' : "",
                                                     color: checkBackGroupItem(cell)  
                                                  }}
                                            {...cell.getCellProps()} >
                                            <div className="d-flex justify-content-between align-items-center" >
                                                <span className="ml-2"
                                                    style={{ textAlign: 'left' }}>
                                                    {checkHeader(cell.column.Header, cell, i)}
                                                    {/* {cell.column.Header === "Time" ?
                                                        (changeDataFullFormat(cell.value))
                                                        :
                                                        cell.column.Header === "Button" ?
                                                            <a href={"" + cell.value} target="_blank">
                                                                {cell.column.buttonName}
                                                            </a> : cell.render('Cell')} */}
                                                    {/* {cell.column.Header === "Redo" ? "link" : "link2"} */}
                                                </span>
                                                <div>
                                                    <FontAwesomeIcon
                                                        onClick={() => onOpenEditCompany(pageIndex * 10 + i)}
                                                        style={{
                                                            width: '15px',
                                                            color: 'green',
                                                            fontSize: '1.4rem',
                                                            cursor: 'pointer',
                                                        }}
                                                        className={(cell.column.Header === "Name" && showIconOnName) ? "btn__add_icon icon mr-2" : "op-hidden"}
                                                        icon={faEdit}
                                                    />
                                                    <FontAwesomeIcon
                                                        onClick={() => onOpenHistory(pageIndex * 10 + i)}
                                                        style={{
                                                            width: '15px',
                                                            color: 'blueviolet',
                                                            fontSize: '1.4rem',
                                                            cursor: 'pointer',
                                                        }}
                                                        className={(cell.column.Header === "Name" && showIconOnName) ? "btn__add_icon icon mr-2" : "op-hidden"}
                                                        icon={faHistory}
                                                    />
                                                </div>

                                            </div>
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

function CompanyItemComponent(props) {
    const { supportFunction1 } = props;
    const pageIndexShow = props.pageIndexShow || 10;
    const auth = useSelector(state => state.auth);
    const { role } = auth.user;

    console.log("props", props)
    const [selectIndex, setSelectIndex ] =useState(0);

    function onOpenEditCompany(data, pageIndex) {
        props.onOpenEditCompany(data, pageIndex)
    };

    function onOpenHistory(data, pageIndex) {
        props.onOpenHistory(data, pageIndex)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const data = React.useMemo(() => props.data);

   // console.log("data", data)

    const COLUMNS_SELECT = {
        guest: [
            {
                Header: 'ID',
                accessor: 'guest_id',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '70px',  }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            // {
            //     Header: 'Sex',
            //     accessor: 'gender',
            //     class: 'with-70',
            //     style: { fontSize: '1.4rem', width: '270px' }
            // },
            {
                Header: 'Email',
                accessor: 'email1',
                class: 'with-150',
                style: { fontSize: '1.4rem', width: '270px' }
            },
                        {
                Header: 'Email 2',
                accessor: 'email2',
                class: 'with-150',
                style: { fontSize: '1.4rem', width: '270px' }
            },
                        {
                Header: 'Email 3',
                accessor: 'email3',
                class: 'with-150',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Birth Day',
                accessor: 'birth_day',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'passport_number',
                accessor: 'passport_number',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Phone',
                accessor: 'phone',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '100px' }
            },
            {
                Header: 'Remark',
                accessor: 'remark',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Company',
                class: 'with-270',
                accessor: 'company_name',
                style: { fontSize: '1.4rem', width: '270px' }
            },
        ],
        company: [
            {
                Header: 'ID',
                accessor: 'company_id',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '70px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px', }
            },
            {
                Header: 'Represent',
                accessor: 'represent_name',
                class: 'with-200',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Address',
                accessor: 'address',
                class: 'with-300',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Phone',
                accessor: 'tel',
                class: 'with-120',
                style: { fontSize: '1.4rem', width: '80px' }
            },
            {
                Header: 'Tax',
                accessor: 'tax',
                class: 'with-120',
                style: { fontSize: '1.4rem', width: '100px' }
            },
            {
                Header: 'Contract',
                accessor: 'contract',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '50px' }
            },
            {
                Header: 'Travel',
                accessor: 'travel',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '50px' }
            },
            {
                Header: 'Special',
                accessor: 'special',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Branch',
                accessor: 'branch',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '70px' }
            },
            {
                Header: 'Date Created',
                accessor: 'created_at',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '100px' }
            }
            //{
             //   Header: 'Special Rate',
             //   accessor: 'special_rate',
             //   style: { fontSize: '1.4rem', width: '70px' }
            //}
            // address
        ],
        guestEditStory: [
            {
                Header: 'Time',
                accessor: 'time',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '70px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Sex',
                accessor: 'gender',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Email',
                accessor: 'email1',
                class: 'with-150',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Birth Day',
                accessor: 'birth_day',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'passport_number',
                accessor: 'passport_number',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Phone',
                accessor: 'phone',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '100px' }
            },
            {
                Header: 'Remark',
                accessor: 'remark',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Company',
                class: 'with-270',
                accessor: ' company_name',
                style: { fontSize: '1.4rem', width: '270px' }
            },
        ],
        companyEditStory: [
            {
                Header: 'Time',
                accessor: 'time',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '70px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Represent',
                accessor: 'represent_name',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Address',
                accessor: 'address',
                class: 'with-300',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Phone',
                accessor: 'tel',
                style: { fontSize: '1.4rem', width: '100px' }
            },
            {
                Header: 'Tax',
                accessor: 'tax',
                style: { fontSize: '1.4rem', width: '100px' }
            },
            {
                Header: 'Contract',
                accessor: 'contract',
                style: { fontSize: '1.4rem', width: '50px' }
            },
            {
                Header: 'Branch',
                accessor: 'branch',
                style: { fontSize: '1.4rem', width: '60px' }
            },
            {
                Header: 'Special',
                accessor: 'special',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            // {
            //     Header: 'Special Rate',
            //     accessor: 'special_rate',
            //     style: { fontSize: '1.4rem', width: '70px' }
            // }
        ],
        guestOnCompany: [
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Sex',
                accessor: 'gender',
                class: 'with-70',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Email',
                accessor: 'email1',
                class: 'with-150',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Birth Day',
                accessor: 'birth_day',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Remark',
                accessor: 'remark',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "File Guest",
            }
        ],
        guestCheckIn: [
            {
                Header: 'No',
                accessor: 'index',
                class: 'with-10',
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
            },
            {
                Header :'Birthday',
                accessor:'birth_day',
                class: 'with-100'
            },
            {
                Header: 'Passport',
                accessor: 'passport_number',
                class: 'with-20',
            },
            // {
            //     Header: 'PassportPicture',
            //     accessor: 'passport',
            //     class: 'op-hidden',
            // },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
            },
            {
                Header: 'Room',
                accessor: 'roomNumber',
                class: 'with-20',
            },
            {
                Header: 'View',
                accessor: '',
                class: 'with-20',
            }
        ],
        guestCheckOutAcc: [
            {
                Header: 'No',
                accessor: 'index',
                class: 'with-10',
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
            },
            {
                Header: 'Room',
                accessor: 'roomNumber',
                class: 'with-20',
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
            },
            {
                Header: 'VAT request',
                accessor: 'vat',
                class: 'with-100',
            },
            {
                Header: 'Remark',
                accessor: 'remark',
                class: 'with-350',
            },
            {
                Header: 'Remark VAT',
                accessor: 'remarkVAT',
                class: 'with-350',
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "File Guest",
            }
        ],
        bookingEditStory: [
            {
                Header: 'Time',
                accessor: 'time',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '70px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomNumber',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '20px' }
            },
            {
                Header: 'Price',
                accessor: 'price',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '20px' }
            },
            {
                Header: 'Mail',
                accessor: 'mail',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '120px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '120px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '120px' }
            },
            {
                Header: 'Request1',
                accessor: 'request1',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
            {
                Header: 'Request2',
                accessor: 'request2',
                class: 'with-100',
                style: { fontSize: '1.4rem', width: '270px' }
            },
        ],
        cancelList: [
            {
                Header: 'ID',
                accessor: 'booking_id',
                class: 'with-70',
                style: { fontSize: '1.3rem', width: '50px' }
            },
            {
                Header: 'Date',
                accessor: 'date',
                class: 'with-120',
                style: { fontSize: '1.3rem', width: '120px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Email',
                accessor: 'email',
                class: 'with-150',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Company',
                class: 'with-270',
                accessor: 'company_name',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Request1',
                accessor: 'request1',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Request2',
                accessor: 'request2',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "File Guest",
            }
        ],
        makeHotelInvoice: [
            {
                Header: 'ID Invoice',
                accessor: 'booking_id',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'ID Group',
                accessor: 'group_id',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Price',
                accessor: 'price',
                class: 'with-50',
                style: { fontSize: '1.4rem', width: '20px' }
            },
            {
                Header: 'HI Number',
                accessor: 'invoice_id',
                class: 'with-50',
                style: { fontSize: '1.4rem', width: '20px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "Print Single",
            }

        ],
        roomOnWaitingList: [
            {
                Header: 'Created At',
                accessor: 'createdAt',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Price',
                accessor: 'price',
                class: 'with-50',
                style: { fontSize: '1.4rem', width: '20px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "View Room",
            }

        ],
        redoInvoice: [
            {
                Header: 'ID',
                accessor: 'booking_id',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Price',
                accessor: 'price',
                class: 'with-50',
                style: { fontSize: '1.4rem', width: '20px' }
            },
        ],
        invoiceManage: [
            {
                Header: 'Created Date',
                accessor: 'createdDate',
                class: 'with-150',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Invoice Number',
                accessor: 'invoice_id',
                class: 'with-150',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkIn',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkOut',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "View PDF",
            },
            {
                Header: 'Button',
                accessor: 'button2',
                buttonName: "View Room",
            }
        ],
        invoiceManage2: [
            {
                Header: 'Select',
                accessor: 'index',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Invoice Number',
                accessor: 'invoice_id',
                class: 'with-150',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkIn',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkOut',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "View PDF",
            },
            {
                Header: 'Button',
                accessor: 'button2',
                buttonName: "View Room",
            }
        ],
        flightManage: [
            {
                Header: 'Name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Type Car',
                accessor: 'typeCar',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Flight Number',
                accessor: 'flightNumber',
                class: 'with-100',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Flight Time / Date',
                accessor: 'flightTime',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'RentCar Content',
                accessor: 'rentCarContent',
                class: 'with-350',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "File Guest",
            }
        ],
        glistCheckIn: [
            {
                Header: 'Room',
                accessor: 'room',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'remark',
                accessor: 'remark',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Request 2',
                accessor: 'request2',
                class: 'with-270',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'PickUp',
                accessor: 'pickUp',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'DropOff',
                accessor: 'dropOff',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'RentCar',
                accessor: 'rentCarList',
                class: 'with-50',
                style: { fontSize: '1.3rem', width: '270px' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                class: 'with-50',
                buttonName: "Go to file",
                style: { fontSize: '1.3rem', width: '270px' }
            },
        ],
        guestCheckInManage: [
            {
                Header: 'name',
                accessor: 'name',
                class: 'with-270',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Pass Port',
                accessor: 'passport_number',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Birth Day',
                accessor: 'birth_day',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-50',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Button',
                accessor: 'button',
                buttonName: "File Guest",
            }
        ],
        guestStayHistory: [
            {
                Header: 'Branch',
                accessor: 'branchID',
                class: 'with-70',
                style: { fontSize: '1.3rem', with:'50px' }
            },
            {
                Header: 'Room',
                accessor: 'roomSelect',
                class: 'with-70',
                style: { fontSize: '1.3rem', with:'50px' }
            },
            {
                Header: 'Price',
                accessor: 'price',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Check In',
                accessor: 'checkin',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Check Out',
                accessor: 'checkout',
                class: 'with-100',
                style: { fontSize: '1.3rem' }
            },
            {
                Header: 'Request2',
                accessor:'request2',
                class: 'with-270',
                style: { fontSize: '1.3rem' }
            }
        ]
    };

    function onChangePassPort(index) {
        props.onChangeSelectIndex2(data[index].passport)
    }

    return (
        <Styles>
            <Table
                columns={COLUMNS_SELECT[props.type]}
                type = {props.type}
                data={data}
                selectIndex = {selectIndex}
                onChangeSelectIndex={setSelectIndex}
                onChangeSelectIndex2={onChangePassPort}
                supportFunction1={supportFunction1}
                search={props.search}
                role={role}
                pageIndexShow={pageIndexShow}
                showIconOnName={(props.type === "guest" && role === 0 )
                        || (props.type === "company" && (role !== 0 && role !== 4))}
                onOpenEditCompany={onOpenEditCompany}
                onOpenHistory={onOpenHistory}
            />
        </Styles>
    );
}

export default CompanyItemComponent
